import React from 'react';
import classNames from 'classnames';
import { Typography } from "../../../components/Typography/Typography";
import { DRILL_NAVIGATION_BACKGROUND_COLOR } from "../../../constants/styles";
import { makeStyles } from "../../../styles/index";
var useStyles = makeStyles(function (theme) { return ({
    root: {
        touchAction: 'manipulation',
        flex: 1,
        pointerEvents: 'auto',
        display: 'flex',
        boxSizing: 'border-box',
        justifyContent: 'start',
        alignItems: 'center',
        // defaultThemeに値がないので直書き
        backgroundColor: DRILL_NAVIGATION_BACKGROUND_COLOR,
        lineHeight: 26,
        width: '100%',
        height: 48,
        position: 'relative',
    },
    selected: {
        // defaultThemeに値がないので直書き
        backgroundColor: '#4180FF',
    },
    subjectIcon: {
        marginLeft: theme.spacing(3),
    },
    selectedSubjectValue: {
        color: theme.palette.common.white,
    },
}); }, { name: 'SnSubjectItem' });
export var SubjectItem = function (_a) {
    var _b, _c;
    var subject = _a.subject, selected = _a.selected, disabled = _a.disabled, SubjectIcon = _a.SubjectIcon, subjectName = _a.subjectName, subjectColor = _a.subjectColor, onClickSubject = _a.onClickSubject;
    var classes = useStyles();
    var rootClass = classNames(classes.root, (_b = {}, _b[classes.selected] = selected, _b));
    var subjectValueClass = classNames((_c = {}, _c[classes.selectedSubjectValue] = selected, _c));
    var handleClickSubject = function () {
        if (disabled) {
            // 無効のときは何もしない
            return;
        }
        onClickSubject(subject);
    };
    return (React.createElement("div", { className: rootClass, onClick: handleClickSubject }, SubjectIcon && (React.createElement(React.Fragment, null,
        React.createElement(SubjectIcon, { className: classes.subjectIcon, style: { color: selected ? '#ffffff' : subjectColor === null || subjectColor === void 0 ? void 0 : subjectColor.primary } }),
        React.createElement(Typography, { bold: true, className: subjectValueClass }, subjectName)))));
};
